import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      transform="scale(0.8 0.8)"
      d="M16 0L20.2321 10.1751L31.2169 11.0557L22.8476 18.2249L25.4046 28.9443L16 23.2L6.59544 28.9443L9.15239 18.2249L0.783095 11.0557L11.7679 10.1751L16 0Z"
      fill={fill}
    />
  </g>
);

export default Icon;
